import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";
import { MLOContext } from "@/lib/mloContext";
import { mloPhotoUrl } from "@/lib/photo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Loads the MLO record for /:slug/* routes and provides it to landing sections.
export const MLOProvider = ({ children }) => {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, mlo: null, notFound: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/mlos/${encodeURIComponent(slug)}/public`);
        if (cancelled) return;
        setState({
          loading: false,
          notFound: false,
          mlo: {
            ...res.data,
            photoUrl: mloPhotoUrl(res.data),
            photoSecondaryUrl: mloPhotoUrl(res.data, "secondary"),
          },
        });
      } catch (e) {
        if (!cancelled) setState({ loading: false, mlo: null, notFound: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (state.loading) {
    return (
      <div className="min-h-screen bg-linen flex items-center justify-center text-navy" data-testid="mlo-provider-loading">
        <p className="text-sm text-ink-500">Loading…</p>
      </div>
    );
  }
  if (state.notFound) return <Navigate to="/apply" replace />;

  return <MLOContext.Provider value={state.mlo}>{children}</MLOContext.Provider>;
};
